import { Platform } from 'react-native'

// Paragraph/P2-Regular — `size/p2` 14, `line-height/p2` 20.
export const FIELD_TEXT_CLASS = 'text-[0.875rem] leading-[1.25rem]'

// Multi-line fields stay on Size/P1 on native; the mobile frames specify 16/24.
export const MULTILINE_FIELD_TEXT_CLASS =
    Platform.OS === 'web' ? FIELD_TEXT_CLASS : 'text-[16px] leading-[24px]'
